export default __webpack_public_path__ + "static/media/11.631c03cf.jpeg";